<div class="OptionsWrapper">

    <div>
        <img *ngIf="this.OptionsService.ShowOptions === true" class="showOptionsButton" (click)="toggleOptions()"
            src="assets/images/misc/gear.png" />
        <img *ngIf="this.OptionsService.ShowOptions === false" class="hideOptionsButton" (click)="toggleOptions()"
            src="assets/images/misc/gear.png" />
    </div>

    <div class="OptionButtonsContainer" *ngIf="this.OptionsService.ShowOptions === true">

        <button class="optionButton" (click)="resetAll()">Reset All</button>

        <button class="optionButton" (click)="toggleSound()">Sound
            <a *ngIf="this.RoomEventService.isSoundOn === true" [ngStyle]="{'color': 'lime'}">On</a>
            <a *ngIf="this.RoomEventService.isSoundOn === false" [ngStyle]="{'color': 'red'}">Off</a>
        </button>

        <button class="optionButton" (click)="godMode()">Godmode
            <a *ngIf="this.PlayerInventoryService.isGodmodeOn === true" [ngStyle]="{'color': 'lime'}">On</a>
            <a *ngIf="this.PlayerInventoryService.isGodmodeOn === false" [ngStyle]="{'color': 'red'}">Off</a>
        </button>

        <button class="optionButton" (click)="toggleDungeonPath()">Toggle Dungeon
            <a *ngIf="this.DungeonPathService.showDungeonPath === true" [ngStyle]="{'color': 'lime'}">Path</a>
            <a *ngIf="this.DungeonPathService.showDungeonPath === true" [ngStyle]="{'color': 'black'}"> / Room</a>
            <a *ngIf="this.DungeonPathService.showDungeonPath === false" [ngStyle]="{'color': 'black'}">Path / </a>
            <a *ngIf="this.DungeonPathService.showDungeonPath === false" [ngStyle]="{'color': 'lime'}">Room</a>
        </button>

        <button class="optionButton" (click)="toggleDevInfo()">Show Dev Info
            <a *ngIf="this.DungeonPathService.showDevInfo === true" [ngStyle]="{'color': 'lime'}">On</a>
            <a *ngIf="this.DungeonPathService.showDevInfo === false" [ngStyle]="{'color': 'red'}">Off</a>
        </button>

        <button *ngIf="this.DungeonPathService.showDevInfo === true" class="optionButton"
            (click)="generate()">Regenerate Map</button>
        <button *ngIf="this.DungeonPathService.showDevInfo === true" class="optionButton" (click)="redrawLines()">Redraw
            Lines</button>
        <button *ngIf="this.DungeonPathService.showDevInfo === true" class="optionButton"
            (click)="resetPlayerPos()">Reset Player Pos</button>
        <button *ngIf="this.DungeonPathService.showDevInfo === true" class="optionButton"
            (click)="toggleRoomGaps()">Toggle Room Gaps</button>

    </div>

    <div class="OptionButtonsContainer" *ngIf="this.OptionsService.HideOptions === true">

        <button class="optionButtonHide">Reset All</button>
        <button class="optionButtonHide">Regenerate Map</button>
        <button class="optionButtonHide">Redraw Lines</button>
        <button class="optionButtonHide">Reset Player Pos</button>

        <button class="optionButtonHide">Godmode
            <a *ngIf="this.PlayerInventoryService.isGodmodeOn === true" [ngStyle]="{'color': 'lime'}">On</a>
            <a *ngIf="this.PlayerInventoryService.isGodmodeOn === false" [ngStyle]="{'color': 'red'}">Off</a>
        </button>

        <button class="optionButtonHide">Toggle Dungeon
            <a *ngIf="this.DungeonPathService.showDungeonPath === true" [ngStyle]="{'color': 'lime'}">Path</a>
            <a *ngIf="this.DungeonPathService.showDungeonPath === true" [ngStyle]="{'color': 'black'}"> / Room</a>
            <a *ngIf="this.DungeonPathService.showDungeonPath === false" [ngStyle]="{'color': 'black'}">Path / </a>
            <a *ngIf="this.DungeonPathService.showDungeonPath === false" [ngStyle]="{'color': 'lime'}">Room</a>
        </button>

        <button class="optionButtonHide">Dev Info
            <a *ngIf="this.DungeonPathService.showDevInfo === true" [ngStyle]="{'color': 'lime'}">On</a>
            <a *ngIf="this.DungeonPathService.showDevInfo === false" [ngStyle]="{'color': 'red'}">Off</a>
        </button>

    </div>

</div>